<div class="import-markets-form">
    <div class="config-warning">
        <span class="k-icon k-i-warning"></span>
        <div>
            <strong>Importing will replace every market rule currently on this screen.</strong>
            <p>
                Including any unsaved changes. This cannot be undone once saved &mdash; you can
                still edit individual rows after importing, and nothing is saved to the database
                until you click Save.
            </p>
        </div>
    </div>

    <div class="form-row">
        <label>Choose a file <span class="optional">(or paste below)</span></label>
        <div class="file-row">
            <input type="file" accept=".csv,.txt" #fileInput (change)="onFileSelected($event)" hidden />
            <button kendoButton (click)="fileInput.click()">Choose File</button>
            <span class="file-name" *ngIf="fileName">{{ fileName }}</span>
        </div>
    </div>

    <div class="form-row">
        <label>CSV contents</label>
        <textarea class="import-textarea mono" [(ngModel)]="csvText" name="csvText" rows="10"
                  placeholder="Pipe or comma delimited, same columns as market_rules.csv / simple_market_assignment.csv"></textarea>
    </div>

    <div class="config-warning config-warning-error" *ngIf="errors.length">
        <span class="k-icon k-i-warning"></span>
        <div>
            <strong>These must be fixed before this can be imported.</strong>
            <ul>
                <li *ngFor="let error of errors">{{ error }}</li>
            </ul>
        </div>
    </div>

    <kendo-dialog-actions [layout]="'normal'">
        <button kendoButton (click)="onCancel()">Cancel</button>
        <button kendoButton [primary]="true" [disabled]="!csvText.trim()" (click)="onImport()">Import</button>
    </kendo-dialog-actions>
</div>
